import { hasPermission, hasActiveFeatureGate } from '@ubisend/pulse-auth';

import { TelegramSettings } from './Pages/index';

const routes = [
  {
    name: 'Telegram',
    path: '/telegram-link',
    component: TelegramSettings,
    canAccess: [
      hasActiveFeatureGate('channel - telegram'),
      hasPermission('view telegram settings')
    ],
    actions: [
      {
        title: 'Manage your Telegram channel',
        description: 'Connect, disconnect, or edit your Telegram integration.',
        icon: 'lightningBolt'
      }
    ]
  }
];

export default routes;
